import { useQuery } from 'hooks/useCustomQuery';
import { useSelector } from 'react-redux';
import getEngineLocations from 'API/EngineLocation/getEngineLocations';

const useGetEngineLocations = (setEngineLocations) => {
    const { currentScope } = useSelector((state) => ({ ...state.login }));
    return useQuery({
        queryKey: ['engineLocations', currentScope],
        queryFn: async () => {
            const data = await getEngineLocations(currentScope).then((res) => {
                setEngineLocations(res);
                return res;
            });
            return data;
        },
        refetchOnWindowFocus: false,
        enabled: !!currentScope,
        staleTime: 0,
    });
};

export default useGetEngineLocations;
